<template>
  <!-- <div :class="className" :style="{ height: height, width: width }"></div> -->
  <div :class="className" :style="{ width: '100%', height: '100%' }" />
</template>

<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    color: {
      type: String,
      default: function() {
        return "#0AD1FC";
      }
    },
    color2: {
      type: String,
      default: function() {
        return "rgba(16, 161, 221, 0)";
      }
    }
  },
  data() {
    return {
      chart: null
    };
  },
  created() {
    console.log("itemData", this.itemData);
  },
  mounted() {
    if (this.itemData && this.itemData.viewId) {
      this.getChartData(this.itemData.viewId);
    } else {
      this.$nextTick(() => {
        this.initChart();
      });
    }
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    async getChartData(viewId) {
      const { data } = await this.$api.getChartData({
        id: viewId
      });
      const { legend, seriesDataList, xAxisData } = data;
      let series = seriesDataList.map(el => {
        return {
          name: el.name,
          type: "line",
          stack: "Total",
          //设置面积区域为渐变效果
          // areaStyle: {
          //   color: echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //     {
          //       offset: 0,
          //       color: this.color || "#0AD1FC"
          //     },
          //     {
          //       offset: 1,
          //       color: this.color2 || "rgba(16, 161, 221, 0)"
          //     }
          //   ])
          // },
          areaStyle: {},
          emphasis: {
            focus: "series"
          },
          data: el.dataList
        };
      });
      this.initChart(series, xAxisData);
    },

    initChart(series = null, xAxisData = null) {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(series, xAxisData);
    },

    setOptions(series, xAxisData) {
      let _this = this;
      let option = {
        // color: [_this.color || "#0AD1FC"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        grid: {
          left: "0%",
          right: "0%",
          top: 0,
          bottom: "0%",
          containLabel: true
        },
        xAxis: [
          {
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function() {
                return "";
              }
            },
            data: xAxisData || ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            minorTick: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              formatter: function() {
                return "";
              }
            }
          }
        ],
        series: series || [
          {
            name: "Email",
            type: "line",
            stack: "Total",
            //设置面积区域为渐变效果
            areaStyle: {
              color: echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: _this.color || "#0AD1FC"
                },
                {
                  offset: 1,
                  color: _this.color2 || "rgba(16, 161, 221, 0)"
                }
              ])
            },
            emphasis: {
              focus: "series"
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          }
        ]
      };

      this.chart.setOption(option);
    }
  }
};
</script>
